import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const LLMPrompts = () => {
  return (
    <>
      <Helmet>
        <title>LLM Prompts - AutoScript Admin</title>
      </Helmet>
      <Header title="LLM Prompts" />
      <Content />
    </>
  );
};
